import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const PaperSummaryView = ({ summaryData }) => {
    const [expandedTopic, setExpandedTopic] = useState(null);

    if (!summaryData || !summaryData.summary) {
        return (
            <div className="flex items-center justify-center h-full text-gray-400">
                <p>Loading summary...</p>
            </div>
        );
    }

    const { summary } = summaryData;

    return (
        <div className="max-w-4xl mx-auto p-6 space-y-8">
            {/* Overall Summary */}
            <section className="bg-purple-900/10 rounded-lg border border-purple-900/20 p-6">
                <h2 className="text-2xl font-semibold text-purple-400 mb-4">Overall Summary</h2>
                <p className="text-gray-300 leading-relaxed">{summary.overall_summary}</p>
            </section>

            {/* Topic-wise Summary */}
            <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-purple-400 mb-4">Topic-wise Summary</h2>
                {summary.topicwise_summary.map((topic, index) => (
                    <div
                        key={index}
                        className="bg-purple-900/10 rounded-lg border border-purple-900/20 overflow-hidden"
                    >
                        <button
                            className="w-full px-6 py-4 flex justify-between items-center text-left"
                            onClick={() => setExpandedTopic(expandedTopic === index ? null : index)}
                        >
                            <h3 className="text-lg font-medium text-purple-400">{topic.topic}</h3>
                            {expandedTopic === index ? (
                                <ChevronUp className="w-5 h-5 text-purple-400" />
                            ) : (
                                <ChevronDown className="w-5 h-5 text-purple-400" />
                            )}
                        </button>
                        {expandedTopic === index && (
                            <div className="px-6 pb-4">
                                <p className="text-gray-300">{topic.summary}</p>
                            </div>
                        )}
                    </div>
                ))}
            </section>
        </div>
    );
};

export default PaperSummaryView; 